// Utils
import cn from '../../../utils/cn';

// Components
import DetailHeaderFieldRenderer from '../DetailHeaderFieldRenderer/DetailHeaderFieldRenderer';

// Styles
import styles from './BannerContentRow.module.css';

/**
 * @param {ApiDetailHeaderFieldset} fieldset
 * @returns {boolean}
 */
const fieldsetContainsTable = (fieldset) => (
  fieldset.fields?.some((field) => Boolean(field.table)) ?? false
);

/**
 * BannerContentRow component - Flexible content row with fieldsets
 * @param {object} props - Component props
 * @param {Array<{fields: Array<any>}>} [props.fieldsets=[]] - Array of fieldsets to display (ApiDetailHeaderFieldset[])
 * @param {string} [props.className] - Additional CSS classes
 * @returns {JSX.Element}
 */
function BannerContentRow({
  fieldsets = [],
  className,
}) {
  /**
   * Render a fieldset
   * @param {ApiDetailHeaderFieldset} fieldset - The fieldset to render
   * @param {number} index - The index of the fieldset
   * @returns {JSX.Element | null}
   */
  const renderFieldset = (fieldset, index) => {
    if (!fieldset.fields || fieldset.fields.length === 0) {
      return null;
    }

    return (
      <div
        key={index}
        className={cn([
          styles['fieldset-container'],
          styles['content-item'],
          fieldsetContainsTable(fieldset) && styles['fieldset-container-table'],
        ])}
      >
        {fieldset.title && (
          <h3 className={styles['fieldset-title']}>{fieldset.title}</h3>
        )}
        {fieldset.fields.map((/** @type {ApiDetailHeaderField} */ field) => (
          <DetailHeaderFieldRenderer
            key={field.text?.id || field.table?.id || field.boolean?.id || field.image?.id || index}
            field={field}
          />
        ))}
      </div>
    );
  };

  return (
    <div className={cn([styles['banner-content-row'], className])}>
      {fieldsets.map((/** @type {ApiDetailHeaderFieldset} */ fieldset, /** @type {number} */ index) => renderFieldset(fieldset, index))}
    </div>
  );
}

export default BannerContentRow;
